export default __webpack_public_path__ + "./assets/og_image__e4e84b49f0272d436190700a60598a84.jpg";